<template>
  <v-container class="iframe-body modal_content px-6">
    <div>
      <v-img
        class="mx-auto ml-sm-0"
        :max-height="94"
        :max-width="103"
        src="@/assets/img-success.png"
      />
    </div>

    <h1 class="text-center text-sm-left mb-5 ">
      {{ $t('successful.title') }}
    </h1>
    <div class="outline-box">
      <img
        height="19"
        width="19"
        src="@/assets/icon-sucessfully.svg"
        style="margin:auto;"
      />

      <p>
        {{ $t('successful.text1[0]') }} {{ envelopeID }}
        {{ $t('successful.text1[1]') }} {{ listDocs }}
        <span style="font-weight: 700">{{ $t('successful.text1[2]') }}</span>
      </p>
    </div>

    <v-row justify="center">
      <v-col cols="12" class="d-none d-sm-flex">
        <div class="link-inline">
          <p>
            {{ $t('successful.text2') }}
          </p>
        </div>
      </v-col>
      <v-col cols="12" class="d-none d-sm-flex">
        <div>
          {{ $t('successful.link[0]') }}
          <a @click="onChain()">
            {{ $t('successful.link[1]') }}
            <img src="@/assets/link.svg" class="Shape" />
          </a>
          {{ $t('successful.link[2]') }}
          <a @click="openSea()">
            {{ $t('successful.link[3]') }}
            <img src="@/assets/link.svg" class="Shape" />
          </a>
        </div>
      </v-col>
    </v-row>

    <v-footer fixed class="iframe-footer">
      <v-container grid-list-md text-center>
        <v-layout justify-end>
          <v-btn
            id="advance-btn"
            depressed
            @click="submitStep"
            class="advance button-iframe"
            >{{ $t('button.done') }}</v-btn
          >
        </v-layout>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import mixinQES from '../QES/mixinQES';

export default {
  mixins: [mixinQES],
  computed: {
    ...mapGetters(['envelopeID', 'redirectUrl', 'documents']),

    listDocs() {
      if (this.documents?.length == 1) {
        return this.documents.join(', ');
      } else if (this.documents?.length > 1) {
        let arr = [...this.documents];
        let last = arr.splice(-1);
        last.unshift(' and');
        return arr.join(', ') + last.join(' ');
      } else {
        return '';
      }
    },
  },
  methods: {
    onChain() {
      this.$gtag.event('Link para o polyscan', {
        event_category: 'ETH',
        event_label: 'Success screen',
      });
      const url =
        'https://mumbai.polygonscan.com/address/0x1B58E3347E5cC1F5A787f3A719bC042ef17d7324';

      window.open(url, '_blank');
    },
    openSea() {
      this.$gtag.event('Link para o Opensea', {
        event_category: 'ETH',
        event_label: 'Success screen',
      });
      const url =
        'https://testnets.opensea.io/collection/wallid-proof-of-signature-nfts';

      window.open(url, '_blank');
    },
    submitStep() {
      console.log('redirect_url: ', this.redirectUrl);
      if (this.redirectUrl) {
        window.location.replace(this.redirectUrl);
      }
    },
  },
};
</script>

<style scoped>
.advance.button-iframe {
  text-transform: none;
}
.iframe-body {
  padding: 28px 12px;
}
</style>
<style lang="scss">
img {
  object-fit: contain;
}
.outline-box {
  padding: 15px;
  text-align: left;
  margin: 0 auto;
  margin-bottom: 18px;
  display: flex;
  border-radius: 4px;
  border: solid 1px #00e284;
  background-color: #d9fbed;
  p {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.71;
    letter-spacing: normal;
    color: var(--charcoal-grey);
    margin-bottom: 0;
    margin-left: 16px;
    word-break: break-word;
  }
}
</style>
